import axios from 'axios';

const instance = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: `${API_BASE_URL}/wp-json`,
  timeout: 8000,
});

export default instance;
